<template>
<ItpWidgetCard>
  <ItpBox
    alignItems="center"
    slot="header"
  >
    <strong>
      {{ 'Contracts'|pgettext('Company') }}
    </strong>
    <ItpButton
      :text="'Create contract...'|gettext"
      size="sm"
      variant="light"
      class="ml-auto"
      @click.prevent.stop="evh_3343864469950044_clickPreventStop($event, {})"
    >
    </ItpButton>
  </ItpBox>
  <BListGroup
    v-if="loaded"
  >
    <BListGroupItem
      class="card-body text-center"
      v-if="!items.length"
    >
      <span>
        {{ 'No related contracts.'|pgettext('Company') }}
      </span>
    </BListGroupItem>
    <BListGroupItem
      :key="item.id"
      class="d-flex flex-column"
      v-for="item in items"
    >
      <UcContractCard
        :item="item"
        :displayCounterparty="b_1468474219929533_displayCounterparty"
      >
      </UcContractCard>
    </BListGroupItem>
  </BListGroup>
</ItpWidgetCard>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcCompanyFormContracts extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  company!: object;

  @Watch('company')
  onCompany(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("company")
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_contract', { parameters: { filter: 'counterparty_id eq "' + this.company.id + '"' } })
      .then(resp => _.orderBy(resp.data, ['valid_from', 'valid_to'], ['desc', 'desc']))
  }

  ux!: any;
  b_1468474219929533_displayCounterparty!: any;
  dataMembers = ['items', 'ux', 'b_1468474219929533_displayCounterparty'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
        b_1468474219929533_displayCounterparty: false,
      },
    }
  }

  async evh_3343864469950044_close_7045_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_3343864469950044_close_7045, alias=undefined
    return !!$event.data.modalResult.value
  }

  async act_3343864469950044_showModal_7044_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_3343864469950044_showModal_7044, alias=undefined
    return {
      name: "CreateContract",
      props: {
        clientId: this.company.id,
      }
      ,
    }
  }

  async evh_3343864469950044_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_3343864469950044_reloadComponentData_7046: actions.ReloadComponentDataAction;
    evh_3343864469950044_close_7045: actions.EventHandlerImpl;
    act_3343864469950044_showModal_7044: actions.ShowModalAction;
    evh_3343864469950044_clickPreventStop_7043: actions.EventHandlerImpl;
    evh_3343864469950044_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_3343864469950044_reloadComponentData_7046 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_3343864469950044_close_7045 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_reloadComponentData_7046,
        event: "close",
        when: this.evh_3343864469950044_close_7045_getWhen,
        displayName: "reloadComponentData",
      }
    );
    const act_3343864469950044_showModal_7044 = new actions.ShowModalAction(
      {
        actionArgs: this.act_3343864469950044_showModal_7044_getActionArgs,
        events: [evh_3343864469950044_close_7045],
      }
    );
    const evh_3343864469950044_clickPreventStop_7043 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_showModal_7044,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_3343864469950044_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_clickPreventStop_7043],
      }
    );
    return {
      act_3343864469950044_reloadComponentData_7046,
      evh_3343864469950044_close_7045,
      act_3343864469950044_showModal_7044,
      evh_3343864469950044_clickPreventStop_7043,
      evh_3343864469950044_clickPreventStop,
    }
  }
}

Vue.component("UcCompanyFormContracts", UcCompanyFormContracts);

</script>